module.exports = __webpack_public_path__ + "static/img/hb_7-min.9e99110.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hb_7-min.png
// module id = djag
// module chunks = 1